import React from 'react';
import * as styles from './styles.css';
import grayStars from '../../../../assets/grayStarsLight.svg';
import { Body1, Body2, Image, Label } from '@cian/ui-kit';
import clsx from 'clsx';

export interface INoDataBlockProps {
  isFirstBlock: boolean;
  title: string | null;
  subtitle: string | null;
  tags: { text: string }[];
}

export function NoDataBlock({ title, subtitle, tags, isFirstBlock = false }: INoDataBlockProps) {
  return (
    <div className={clsx(styles['container'], isFirstBlock && styles['first-block-container'])}>
      <div className={styles['icon-wrapper']}>
        <Image height={21} src={grayStars} width={21} />
      </div>
      <div className={styles['info-container']}>
        <Body1>{title}</Body1>
        <Body2>{subtitle}</Body2>
        <div className={styles['badge-container']}>
          {tags.map((tag, index) => {
            return (
              <Label key={index} background="surface-inverted-default" color="text-main-default">
                {tag.text}
              </Label>
            );
          })}
        </div>
      </div>
    </div>
  );
}
